import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";
import { SecureStorage } from "./types";
import { UserInfo } from "../models/Interfaces";
import { infoLog } from "../utils/logger";

export default class NativeEncryptedStorage implements SecureStorage {
  async updateCryptoKey(u: UserInfo, password: string): Promise<void> {
    // Unlike the web implementation, there is no need to manage the crypto key
    // due to SwiftKeychainWrapper and AndroidKeyStore managing encryption.
    return;
  }

  async clear(): Promise<void> {
    await SecureStoragePlugin.clear();
  }

  async getItem<T>(key: string): Promise<T | null> {
    try {
      const result = await SecureStoragePlugin.get({ key });
      if (result.value) {
        return this.deserialize<T>(result.value);
      }
    } catch (error) {
      infoLog(`Failed to get item ${key} from native encrypted storage: ${error}`);
    }
    return null;
  }

  async setItem<T>(key: string, value: T): Promise<T> {
    const serializedVal = await this.serialize(value);
    await SecureStoragePlugin.set({ key, value: serializedVal });
    return value;
  }

  async removeItem(key: string): Promise<void> {
    try {
      await SecureStoragePlugin.remove({ key });
    } catch (error) {
      infoLog(`Failed to remove item ${key} from native encrypted storage: ${error}`);
    }
  }

  async keys(): Promise<string[]> {
    const result = await SecureStoragePlugin.keys();
    return result.value;
  }

  async unlock(password: string): Promise<boolean> {
    // There is no additional unlock step to gain access to native key store
    return true;
  }

  private async serialize<T>(val: T): Promise<string> {
    return JSON.stringify(val);
  }

  private async deserialize<T>(val: string): Promise<T> {
    return JSON.parse(val);
  }
}
